import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import Api from "../../../../Services/Api";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  mapToDDL,
} from "../../../common/mapper";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";
import FlexView from "react-flexview";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { initialData, tableColumns, SAMPLE_DETAIL } from "../config";
import { getUserAccess } from "../../../../Services/Utils";
import { v4 as uuidv4 } from "uuid";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import { validate } from "../util";

class ManagementApprovalModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      warningModalVisible: false,
      printModalVisible: false,
      uploadFileModalVisible: false,
      selectedDataDetailIndex: null,
      moduleName: null,
      moduleCode: null,
      search: {
        kodeVariant: null,
      },
      tableColumns: [],
      dataTable: [],
      tanggalRequest: M().format("DD-MM-YYYY"),
    };
  }

  componentDidMount = async () => {
    console.log(this.props);
    
    this.handleTriggerLoading();
    if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      await this.fetchDataDetail();
    }
    this.setState((prevState) => ({
      ...prevState,
      tableColumns: [
        ...tableColumns.detailPage(
          getUserAccess(
            this.props.menuAccess,
            this.props.selectedCabang?.value
          ),
          this.props.user.user,
          this.handleChecked,
          this.props.controls,
          this.props.actionType
          // this.props.activityType
        ),
      ],
    }));
    this.handleTriggerLoading();
  };

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (prevState.dataTable !== this.state.dataTable) {
  //     this.handleChecked();
  //   }
  // }

  handleChecked = (index, selectedValue) => {
    this.setState((prevState) => {
      const newData = prevState.dataTable.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            checkboxStatus:
              item.checkboxStatus === selectedValue
                ? "INCOMPLETE"
                : selectedValue,
          };
        }
        return item;
      });

      return { dataTable: newData };
    });
  };

  handleWarningModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  handleSubmit = () => {
    const userId = this.props.auth.user.idUser;
    const dataTable = this.state.dataTable.map((item) => ({
      ...item,
      approvedBy: userId,
      approvalStatus: item.checkboxStatus,
    }));

    const formGroup = flattenFormGroupObject(this.props.controls);
    const { nomorDokumenReferensi, approvalStatus, module, ...rest } = formGroup;

    const requestBody = {
      ...rest,
      moduleName: this.state.moduleName, 
      moduleCode: this.state.moduleCode,
      documentReference: nomorDokumenReferensi,
      statusApproval: approvalStatus,
      idApproval: this.props.selectedData?.idApproval,
      kodeCabang: this.props.selectedCabang?.value,
      listDetailApproval: dataTable,
    };

    this.props.onSubmit(requestBody);
  };

  handleValueChangeSearch = (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        [name]: value,
      },
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataDetail = async () => {
    try {
      const response = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).getDetailManagementApproval(this.props.selectedData?.idApproval);

      console.log(response);

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: response.data?.data?.listDetailApproval,
          moduleName: response.data?.data?.moduleName,
          moduleCode: response.data?.data?.moduleCode,
        }));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  render() {
    return (
      <Fragment>
        <SimpleModal
          title="Detail Management Approval"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <div className="grid grid-2x gap-20px grid-mobile-none">
                <div id="grid-1">
                  <SimpleInput
                    id="input_text_table_name_bbn"
                    name="idRequest"
                    label="ID Request"
                    value={this.props.controls?.idRequest?.value}
                    readOnly
                    onChange={({ target }) =>
                      this.props.setValue(target.name, target.value)
                    }
                  />
                  <SimpleDate
                    label="Tanggal Request"
                    disabled
                    date={this.state.tanggalRequest}
                    onChange={(value) =>
                      this.props.setValue(
                        "tanggalRequest",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                  <SimpleInput
                    id="input_text_menu"
                    name="module"
                    label="Modul/Menu"
                    value={this.props.controls?.module?.value}
                    readOnly
                    onChange={({ target }) =>
                      this.props.setValue(target.name, target.value)
                    }
                  />
                </div>
                <div id="grid-2">
                  <SimpleInput
                    id="input_text_document_number"
                    name="documentReference"
                    label="Nomor Dokumen"
                    value={this.props.controls?.nomorDokumenReferensi?.value}
                    readOnly
                    onChange={({ target }) =>
                      this.props.setValue(target.name, target.value)
                    }
                  />
                  <SimpleInput
                    id="input_text_user"
                    name="userPemohon"
                    label="User Pemohon"
                    value={this.props.controls?.userPemohon?.value}
                    readOnly
                    onChange={({ target }) =>
                      this.props.setValue(target.name, target.value)
                    }
                  />
                  <SimpleInput
                    id="input_text_status"
                    name="approvalStatus"
                    label="Status"
                    value={this.props.controls?.approvalStatus?.value}
                    readOnly
                    onChange={({ target }) =>
                      this.props.setValue(target.name, target.value)
                    }
                  />
                </div>
              </div>

              <SimpleDataTable
                data={this.state.dataTable}
                // data={SAMPLE_DETAIL}
                columns={this.state.tableColumns}
                // toCount={this.state.dataTable?.length}
                rowsPerPage={5}
                options={{serverSide: false}}
              />

              {this.props.actionType !== 'view' &&
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <SimpleButton
                    type="button"
                    text="Simpan"
                    disabled={
                      this.props.controls?.approvalStatus?.value == "APPROVED"
                    }
                    onClick={() => this.handleSubmit()}
                  />
                </div>
              }
              
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleWarningModalVisibility()}
              />
            }
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </Fragment>
    );
  }
}

export default withFormGroup(ManagementApprovalModifying);

class AlertModal extends Component {
  render() {
    return (
      <SimpleAlert
        title={"Question"}
        content={
          <div>
            <p>{this.props.warningMessage}</p>
          </div>
        }
        additionalButtons={
          <Fragment>
            <FlexView>
              <SimpleButton
                text="Batal"
                secondary
                onClick={this.props.onClickClose}
              />
              <SimpleButton text="Iya" onClick={this.props.onSubmit} />
            </FlexView>
          </Fragment>
        }
        visible={this.props.modalVisible}
        onClickClose={this.props.onClickClose}
      />
    );
  }
}
